import React from 'react';
import { ShowIf } from 'components/utils';
import {msg} from "constants/message";
import {validatable} from 'components/utils';

class TextArea extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value,
      isValid: true
    }
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });
    if (this.props.triggerOnblur != true) {
      this.props.onChange(e);
    }
  }

  validate() {
    if (!this.state.value.trim() && this.props.require) {
      this.setState({
        isValid: false
      });
      this.textarea.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  handleBlur(e) {
    if (this.props.triggerOnblur == true) {
      this.setState({
        value: e.target.value
      });
      this.props.onChange(e);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value != nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
    if(!nextProps.require || nextProps.value) {
      this.setState({
        isValid: true
      });
    }
  }

  classNames() {
    if (!this.state.isValid && !this.state.value.trim() && this.props.require) {
      return 'pt-input pt-intent-danger';
    } else {
      return 'pt-input';
    }
  }

  handleFocus(e) {
    e.target.select();
  }

  render() {
    return (
      <div className={this.props.className + ' mb18'}>
        <label className="val-title">
          { this.props.label }
          <ShowIf condition={this.props.require}>
            <span className="text-required">&nbsp;*</span>
          </ShowIf>
        </label>
        <textarea onFocus={this.handleFocus.bind(this)} rows={this.props.rows} maxLength={this.props.maxLength}
          ref={(textarea) => { this.textarea = textarea; }}
          onBlur={this.handleBlur.bind(this)}
          className={this.classNames()} value={this.state.value}
          onChange={ this.onChange.bind(this) } placeholder={this.props.placeholder}
          name={this.props.name}/>
        <ShowIf condition={!this.state.isValid}>
          <div className="pt-form-helper-text">{msg.messageDefault}</div>
        </ShowIf>
      </div>
      );
  }
}

TextArea.defaultProps = {
  className: 'col-100',
  label: '',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: '',
  require: false,
  triggerOnblur: false,
  rows: 5,
  maxLength: '',
  value: '',
  name:''
}

export default validatable(TextArea);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/TextArea.jsx